<template>
  <div>
    <!--    页面标题 start -->
    <div v-web-title :data-title="$t('message.order.title')"></div>
    <!--    页面标题 end -->

    <div class="page-content">
      <Row type="flex" justify="center">
        <!--        侧边栏 start -->
        <i-col :lg="4">
          <SideBar class="mobile-no-sidebar" />
        </i-col>
        <!--        侧边栏 end -->
        <i-col :xs="24" :md="24" :lg="12">
          <div class="right-content">
            <!--                        用户已登录的页面 start-->
            <div v-if="isLogin">
              <!--        订单页头部 start-->
              <div class="header-block">
                <div class="title-text">
                  {{ $t("message.order.headerTitle") }}
                </div>
               
              </div>
              <!--        订单页头部 end-->

              <!--        订单列表 start -->
              <div
                v-if="typeOrderList(orderStatus).length === 0"
                class="empty-list"
              >
                <div>
                  <m-icons type="empty" size="80" color="#b2b2b2" />
                </div>
                <div class="empty-list-text">
                  {{ $t("message.order.noOrders") }}
                </div>
              </div>
              <Table size="large" height="500" :columns="columns" :data="data" :span-method="handleSpan"></Table>

              <!--        订单列表 end -->
            </div>
            <!--                        用户已登录的页面 end-->

            <!--                        用户未登录的订单查询页面 start-->
            <div v-else>
              <div class="header-block">
                <div class="title-text">
                  {{ $t("message.order.orderQueryTitle") }}
                </div>
                <Form
                  ref="orderQuery"
                  :model="orderQuery"
                  :rules="ruleOrderQuery"
                  inline
                >
                  <FormItem prop="outTradeNo">
                    <Input
                      type="text"
                      v-model="orderQuery.outTradeNo"
                      :placeholder="
                        $t('message.order.orderQueryInputPlaceholder')
                      "
                    />
                  </FormItem>
                  <FormItem>
                    <Button type="primary" @click="queryOrder"
                      ><span class="button-text">{{
                        $t("message.order.orderQueryButton")
                      }}</span></Button
                    >
                  </FormItem>
                </Form>
                <div class="line line-wrapper" />
                <div class="order-query-des">
                  {{ $t("message.order.orderQueryDes") }}
                </div>
              </div>

              <Modal v-model="isShowSendSuccessModal">
                <div class="send-modal">
                  <Icon type="ios-checkmark-circle" size="20" color="#00C957" />
                  <p class="send-modal-text">
                    {{ $t("message.order.sendModalText") }}
                  </p>
                </div>
                <div slot="footer">
                  <Button type="primary" @click="closeSendModal">OK</Button>
                </div>
              </Modal>
            </div>
            <!--                        用户未登录的订单查询页面 end-->
          </div>
        </i-col>
      </Row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  gotoPage,
  urlRequest,
  getLocalCurrencySymbol,
  getPaymentStatus,
  getLoginStatus,
} from "../../common/common";
import SideBar from "../../components/SideBar/SideBar";
import mIcons from "@/components/m-icons/m-icons.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { mounted } from "vue";

export default {
  name: "Order",

  data() {
    return {
      cityList:[],
      // 登录状态
      // isLogin: false,
      // 获取本地货币符号
      getLocalCurrencySymbol: getLocalCurrencySymbol,
      // 获取本地化支付状态
      getPaymentStatus: getPaymentStatus,
      // 订单数据
      // orderList: {all: []},
      // 订单状态
      orderStatus: "all",
      columns: [
          
        {
          title: "flight No",
          key: "flight_no",
          align: 'center'
        },
        {
          title: "name",
          key: "name",
          align: 'center'
        },
        {
          title:"Total price",
          key:"price",
          align: 'center'

        },
        {
          title:"airport time" ,
          key:"airport_time",
          align: 'center'
        },{
          title:"car type" ,
          key:"car_model",
          align: 'center'
        },
        {
          title:"creation time",
          key:"create_time",
          align: 'center'

        }
      ],
      data: [
        // {
        //   name: "John Brown",
        //   age: 18,
        //   address: "New York No. 1 Lake Park",
        //   date: "2016-10-03",
        // },
        // {
        //   name: "Jim Green",
        //   age: 24,
        //   address: "London No. 1 Lake Park",
        //   date: "2016-10-01",
        // },
        // {
        //   name: "Joe Black",
        //   age: 30,
        //   address: "Sydney No. 1 Lake Park",
        //   date: "2016-10-02",
        // },
        // {
        //   name: "Jon Snow",
        //   age: 26,
        //   address: "Ottawa No. 2 Lake Park",
        //   date: "2016-10-04",
        // },
      ],
      // 用户未登录状态
      // 订单查询表单
      orderQuery: {
        outTradeNo: "",
      },
      // 订单查询表单校验规则
      ruleOrderQuery: {
        outTradeNo: [
          {
            required: true,
            message: this.$t("message.order.orderQueryInputValidate"),
            trigger: "blur",
          },
        ],
      },
      // 是否展示发送邮件成功
      isShowSendSuccessModal: false,
    };
  },

  created() {
    // 加载订单数据
    this.getOrderList();
  },

  methods: {
    ...mapActions([
      // 获取订单列表数据
      "getOrderList",
    ]),

    // 查询订单（未登录时功能）
    // queryOrder() {
    //   this.$refs.orderQuery.validate(valid => {
    //     if (valid) {
    //       console.log('校验通过')
    //       urlRequest({
    //         url: this.api.orderEmail,
    //         method: 'POST',
    //         data: {
    //           'number': this.orderQuery.outTradeNo
    //         }
    //       }).then(res => {
    //         console.log('订单邮件发送成功');
    //         this.isShowSendSuccessModal = true;
    //       });
    //     } else {
    //       console.log('校验失败')
    //     }
    //   });
    // },

    // 关闭邮件发送成功对话框
    closeSendModal() {
      this.isShowSendSuccessModal = false;
    },

    // 切换订单状态
    changeOrderStatus(status) {
      this.orderStatus = status;
    },

    // 获取入住日期
    getCheckinDate(order) {
      return moment(order.check_in_time).format("YYYY-MM-DD");
    },
handleSpan({row, column, rowIndex, columnIndex}){
 
},
    // 获取离店日期
    getCheckoutDate(order) {
      return moment(order.departure_time).format("YYYY-MM-DD");
    },

    // 数据加载
    loadData() {
      // 如果有登录才调用接口查询数据
      if (this.isLogin) {
        urlRequest({
          url: this.api.getOrderList,
          method: "get",
        }).then((res) => {
          if (res.data.code == 200) {
            console.log("订单列表数据: ", res.data.data);
            res.data.data.forEach((item) => {
              this.data.push({
                order_no: item.order_no,
                flight_no: item.flight_no,
                airport_time: item.airport_time,
                car_model:this.cityList[item.car_id-1].label,
                name: item.name,
                order_status: item.order_status,
                car_id: item.car_id,
                price: 'NZ$'+(parseInt(item.amount)+(parseInt(item.luggage_num>0?80:0))).toFixed(2),
                pay_status:item.pay_status===0?"Unpaid":"paid",
                create_time: item.createtime,
              })
              this.data.reverse()
            });
            console.log("columns: ", this.columns);
          }
        });
        
      }
    },
 getCarType() {
      urlRequest({
        url: this.api.getCarType,
        method: "get",
        data: {},
      }).then((res) => {
        if (res.data.code === 200) {
          res.data.data.forEach((item) => {
            this.cityList.push({
              value: item.id,
              label: item.user_num + "-seater" ,
              price: item.price,
              user_num: item.user_num,
            });
          });
          // 假设选中的车型是第一个
         this.maxNum=this.cityList[0].user_num;
        }
      });
    },
    // 跳转到订单详情页面
    gotoOrderDetail(orderId) {
      gotoPage({
        path: "/OrderDetail",
        params: { orderId: orderId },
      });
    },
  },

  computed: {
    ...mapState([
      // 是否登录
      "isLogin",
      // 订单列表数据
      "orderList",
    ]),

    ...mapGetters([
      // 获取不同类型订单列表数据
      "typeOrderList",
    ]),
  },

  watch: {
    // 监听 isLogin状态变化
    isLogin(newIsLogin, oldIsLogin) {
      if (newIsLogin) {
        // 如果新登录，就请求订单列表数据
        this.getOrderList();
      }
    },
  },

  components: {
    SideBar,
    mIcons,
  },
  mounted() {
    // 页面加载时获取订单列表
    this.getCarType();
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/mainStyle.scss";
@import "Order.scss";
</style>
